import { createContext, useContext } from 'react';

/**
 * I-2485: the work area the page on screen is about (`pageWorkAreaIdFor`), given by `Layout` to the
 * page it draws, so a part of the page that reads that work area's words (`usePackageName`) finds it
 * without every caller passing it. Only the id: what is read with it loads with the page's own chunk.
 */
export const PageWorkAreaContext = createContext<string | null | undefined>(null);

export function usePageWorkAreaId(): string | null | undefined {
  return useContext(PageWorkAreaContext);
}
